import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ServiceCard from "./ServiceCard";
import Particle from "../Particle";
import servicesData from "../../data/servicesData"; 

function Services() {

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          OUR <strong className="purple">IT Services</strong>
        </h1>
        <p style={{ color: "white" }}>
          We provide a wide range of IT services tailored to meet the unique needs of your business. Explore our offerings below to discover how we can help you achieve your goals with cutting-edge technology solutions.
        </p>
        <Row>
          {servicesData.map((service, index) => (
            <Col md={4} className="project-card" key={index}>
              <ServiceCard
                imgPath={service.imgPath}
                title={service.title}
                description={service.description}
                bookLink={service.bookLink}
                learnMoreLink={service.learnMoreLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Services;
